import { extendMoment } from 'moment-range';
import Moment from 'moment-timezone';
import wb from '@/registerServiceWorker';
import { isVendorEnabled, thirdPartyKeys } from '@/config/thirdParty';
const timezone = process.env.VUE_APP_TIMEZONE;
/**
 * Smartlook session replay.
 *
 * `smartlook-client` used to be imported statically and initialised whenever
 * `VUE_APP_SMARTLOOK_KEY` was truthy. Truthy is not the same as valid: an
 * unsubstituted `%%SMARTLOOK_KEY%%`, or the literal `DEFAULT_SMARTLOOK_KEY` that
 * `docker-entrypoint.sh` used to bake in, are both truthy, and both were handed
 * straight to the SDK -- which is why a dev box was requesting
 * `manager.eu.smartlook.cloud/rec/log/DEFAULT_SMARTLOOK_KEY`.
 *
 * The key is now validated (Smartlook keys are exactly 40 characters) and the
 * SDK is imported dynamically, so the bundle is not paid for when it is off.
 */
const setupSmartlook = async () => {
    if (!isVendorEnabled('smartlook'))
        return;
    const key = thirdPartyKeys.smartlookKey();
    if (!key)
        return;
    try {
        const { default: Smartlook } = await import(
        /* webpackChunkName: "smartlook" */ 'smartlook-client');
        globalThis.$smartlook = Smartlook;
        const isSmartlookStarted = Smartlook.init(key, { region: 'eu' });
        if (isSmartlookStarted) {
            Smartlook.record({
                forms: true,
                ips: true,
                emails: true,
                numbers: true
            });
        }
    }
    catch (error) {
        // A recording vendor must never take the app down with it.
        console.error('Smartlook failed to initialise', error);
    }
};
/**
 * Setup globalThis
 */
export const setupGlobalThis = (store, router, i18n) => {
    globalThis.$store = store;
    globalThis.$router = router;
    globalThis.$i18n = i18n;
    globalThis.$moment = extendMoment(Moment);
    globalThis.$timezone = timezone;
    setupSmartlook();
    // For Vue3 could become: app.config.globalProperties since Vue.prototype is removed
    globalThis.$workbox = wb;
};
